<div class="p-4 space-y-4">
  <div class="flex items-center gap-3">
    <h1 class="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2">
      <i class="fa-solid fa-paperclip text-app-teal-100"></i>Customer Assets
    </h1>
    <button class="dark-btn dark-btn-sm" (click)="reload()" [disabled]="loading">
      <i class="fa-solid fa-rotate-right mr-1" [class.fa-spin]="loading"></i>Reload
    </button>
    <span class="text-xs text-gray-500 dark:text-gray-400 ml-2">
      Showing <strong>{{ filtered.length }}</strong> of <strong>{{ assets.length }}</strong> assets
    </span>
  </div>

  <!-- Filter bar -->
  <div class="flex flex-wrap items-end gap-3 bg-gray-50 dark:bg-app-black-100 rounded border border-gray-200 dark:border-[#434863] p-3">
    <div>
      <label class="block text-[10px] uppercase text-gray-500 dark:text-gray-400 mb-1">Customer</label>
      <select class="border border-gray-300 dark:border-[#434863] bg-white dark:bg-app-black-100 text-gray-900 dark:text-white rounded px-2 py-1 text-xs"
              [(ngModel)]="filterCustomer">
        <option value="">All customers</option>
        <option *ngFor="let c of distinctCustomers" [value]="c">{{ c }}</option>
      </select>
    </div>
    <div class="flex-1 min-w-[200px]">
      <label class="block text-[10px] uppercase text-gray-500 dark:text-gray-400 mb-1">Search label / filename / category</label>
      <input type="text"
             class="w-full border border-gray-300 dark:border-[#434863] bg-white dark:bg-app-black-100 text-gray-900 dark:text-white rounded px-2 py-1 text-xs"
             [(ngModel)]="filterText"
             placeholder="e.g. integration-guide" />
    </div>
    <button *ngIf="filterCustomer || filterText"
            class="dark-btn dark-btn-sm"
            (click)="filterCustomer = ''; filterText = ''">
      Clear filters
    </button>
  </div>

  <!-- Inline upload -->
  <details class="border border-gray-200 dark:border-[#434863] rounded bg-white dark:bg-app-black-100">
    <summary class="cursor-pointer select-none px-3 py-2 text-sm font-semibold text-gray-900 dark:text-white">
      <i class="fa-solid fa-plus text-app-teal-100 mr-2"></i>Upload new asset
    </summary>
    <div class="px-3 pb-3 pt-1 space-y-2">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label class="block text-[10px] uppercase text-gray-500 dark:text-gray-400 mb-1">Customer slug *</label>
          <select class="w-full border border-gray-300 dark:border-[#434863] bg-white dark:bg-app-black-100 text-gray-900 dark:text-white rounded px-2 py-1 text-xs font-mono"
                  [(ngModel)]="uploadCustomer">
            <option value="" disabled>Select customer…</option>
            <option *ngFor="let c of allCustomerSlugs" [value]="c">{{ c }}</option>
          </select>
          <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-1">
            Slug list pulled from the Customer Directory — pick the permanent customer ID this asset attaches to.
          </p>
        </div>
        <div>
          <label class="block text-[10px] uppercase text-gray-500 dark:text-gray-400 mb-1">Label</label>
          <input type="text"
                 class="w-full border border-gray-300 dark:border-[#434863] bg-white dark:bg-app-black-100 text-gray-900 dark:text-white rounded px-2 py-1 text-xs"
                 [(ngModel)]="uploadLabel"
                 placeholder="Defaults to the filename" />
        </div>
      </div>
      <div class="flex items-center gap-3 flex-wrap">
        <input #customerAssetUploadInput type="file"
               accept=".html,.htm,.pdf,.md,.markdown,.txt"
               class="text-xs text-gray-700 dark:text-gray-300"
               (change)="onFilePicked($event)" />
        <div class="flex items-center gap-3 text-xs">
          <label class="flex items-center gap-1 cursor-pointer">
            <input type="checkbox" [(ngModel)]="uploadVisAdmin" />
            <span class="px-1.5 py-0.5 rounded text-[10px] font-mono uppercase bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200">admin</span>
          </label>
          <label class="flex items-center gap-1 cursor-pointer">
            <input type="checkbox" [(ngModel)]="uploadVisClientAdmin" />
            <span class="px-1.5 py-0.5 rounded text-[10px] font-mono uppercase bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">client_admin</span>
          </label>
          <label class="flex items-center gap-1 cursor-pointer">
            <input type="checkbox" [(ngModel)]="uploadVisMember" />
            <span class="px-1.5 py-0.5 rounded text-[10px] font-mono uppercase bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200">member</span>
          </label>
        </div>
        <button class="dark-btn dark-btn-sm"
                (click)="upload()"
                [disabled]="uploading || !uploadFile || !uploadCustomer.trim()">
          <i class="fa-solid fa-cloud-arrow-up mr-1"></i>{{ uploading ? 'Uploading…' : 'Upload' }}
        </button>
      </div>
      <p class="text-[10px] text-gray-500 dark:text-gray-400">
        700KB binary cap. Accepted: HTML, PDF, Markdown, TXT.
      </p>
    </div>
  </details>

  <!-- Table -->
  <div *ngIf="loading && assets.length === 0" class="text-sm text-gray-500 dark:text-gray-400 italic">
    Loading…
  </div>
  <div *ngIf="!loading && assets.length === 0" class="text-sm text-gray-500 dark:text-gray-400 italic">
    No assets attached to any customer yet. Use Upload above to add one.
  </div>
  <div *ngIf="filtered.length === 0 && assets.length > 0 && (filterCustomer || filterText)" class="text-sm text-gray-500 dark:text-gray-400 italic">
    No assets match the active filters.
  </div>
  <div *ngIf="filtered.length > 0" class="overflow-x-auto border border-gray-200 dark:border-[#434863] rounded">
    <table class="w-full text-xs">
      <thead class="bg-gray-100 dark:bg-app-black-100 text-gray-700 dark:text-gray-300">
        <tr>
          <th class="text-left px-2 py-1.5 font-semibold">Customer</th>
          <th class="text-left px-2 py-1.5 font-semibold">Asset</th>
          <th class="text-left px-2 py-1.5 font-semibold">Type</th>
          <th class="text-right px-2 py-1.5 font-semibold">Size</th>
          <th class="text-left px-2 py-1.5 font-semibold">Visibility</th>
          <th class="text-left px-2 py-1.5 font-semibold">Uploaded ({{ localTzLabel }})</th>
          <th class="text-right px-2 py-1.5 font-semibold w-0">Actions</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-[#434863]">
        <tr *ngFor="let a of filtered; trackBy: trackById"
            class="bg-white dark:bg-app-black-200/50 hover:bg-gray-50 dark:hover:bg-app-black-100">
          <td class="px-2 py-1.5 font-mono text-gray-900 dark:text-white whitespace-nowrap">{{ a.customer_slug }}</td>
          <td class="px-2 py-1.5">
            <div class="font-semibold text-gray-900 dark:text-white">{{ a.label || a.filename }}</div>
            <div class="text-[10px] font-mono text-gray-500 dark:text-gray-400">{{ a.filename }}</div>
          </td>
          <td class="px-2 py-1.5 text-gray-700 dark:text-gray-300">
            <i class="fa-solid mr-1 text-gray-500 dark:text-gray-400" [ngClass]="iconClass(a)"></i>
            <span class="font-mono text-[10px]">{{ a.content_type }}</span>
          </td>
          <td class="px-2 py-1.5 text-right font-mono text-gray-700 dark:text-gray-300">{{ a.size | number }}</td>
          <td class="px-2 py-1.5">
            <span class="inline-flex flex-wrap gap-1">
              <span *ngFor="let r of a.visibility"
                    class="inline-block px-1.5 py-0.5 rounded text-[10px] font-mono uppercase tracking-wide"
                    [class.bg-purple-100]="r === 'admin'"
                    [class.dark:bg-purple-900]="r === 'admin'"
                    [class.text-purple-800]="r === 'admin'"
                    [class.dark:text-purple-200]="r === 'admin'"
                    [class.bg-blue-100]="r === 'client_admin'"
                    [class.dark:bg-blue-900]="r === 'client_admin'"
                    [class.text-blue-800]="r === 'client_admin'"
                    [class.dark:text-blue-200]="r === 'client_admin'"
                    [class.bg-green-100]="r === 'member'"
                    [class.dark:bg-green-900]="r === 'member'"
                    [class.text-green-800]="r === 'member'"
                    [class.dark:text-green-200]="r === 'member'">{{ r }}</span>
              <span *ngIf="!a.visibility?.length"
                    class="inline-block px-1.5 py-0.5 rounded text-[10px] font-mono uppercase tracking-wide bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300">admin-only</span>
            </span>
          </td>
          <td class="px-2 py-1.5 text-gray-700 dark:text-gray-300 whitespace-nowrap">
            <div>{{ a.uploaded_at | date:'yyyy-MM-dd HH:mm' }}</div>
            <div class="text-[10px] font-mono text-gray-500 dark:text-gray-400">{{ a.uploaded_by_email }}</div>
          </td>
          <td class="px-2 py-1.5 text-right whitespace-nowrap">
            <a [href]="serveUrl(a)" target="_blank" rel="noopener"
               class="text-app-teal-100 hover:text-app-teal-200 mr-2" title="Open in new tab">
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </a>
            <button type="button"
                    class="text-app-teal-100 hover:text-app-teal-200 mr-2"
                    (click)="copyUrl(a)" title="Copy served URL">
              <i class="fa-solid fa-link"></i>
            </button>
            <button type="button"
                    class="text-red-500 hover:text-red-600"
                    (click)="deleteAsset(a)" title="Delete">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
